<template>
    <y-row
        v-if="content"
        class="c-enterprise-hero"
    >
        <y-col
            md="12"
            lg="5"
        >
            <img
                v-if="content.image"
                class="c-enterprise-hero__image"
                :class="{'c-enterprise-hero__image--hidden': hideImageOnMobile}"
                :src="imgSrc(content.image)"
                :alt="content.title"
            >
        </y-col>

        <y-col
            md="12"
            lg="7"
        >
            <div
                class="c-enterprise-hero__content-wrapper"
                :class="{'c-enterprise-hero__content-wrapper--hide-bg': hideBackgroundImage}"
            >
                <component
                    :is="tag"
                    v-if="content.title"
                    class="c-enterprise-hero__title"
                    :class="{'c-enterprise-hero__title--center-on-mobile': titleCenterOnMobile}"
                    v-html="textReplacer(content.title, 'color-primary')"
                />

                <p
                    v-if="content.synopsis || content.title2"
                    class="c-enterprise-hero__synopsis"
                >
                    {{ content.synopsis || content.title2 }}
                </p>

                <y-button
                    v-if="content.custom && content.custom['button-link']"
                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                    color="primary"
                    class="start-building-btn"
                    :href="content.custom['button-link']"
                    :to="content.custom['button-link']"
                >
                    {{ content.custom['button-title'] }}
                </y-button>
            </div>
        </y-col>
    </y-row>
</template>

<script>
    // helpers
    import { textReplacer, isLink } from '@/helpers/helpers';

    export default {
        name: 'Hero',

        props: {
            content            : Object,
            reverse            : Boolean,
            hideImageOnMobile  : Boolean,
            hideBackgroundImage: Boolean,
            titleCenterOnMobile: Boolean,
            tag                : {
                default: 'h1',
                type   : String,
            },
        },

        methods: {
            textReplacer,
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss" />
